<template>
 <!-- Designers -->
  <div class="w3-container" id="designers" style="margin-top:75px">
    <h1 class="w3-xxxlarge w3-text-blue"><b>Experts.</b></h1>
    <hr style="width:50px;border:5px solid blue" class="w3-round">
    <p>The best team in the world.</p>
    <p>Bypass the beaucracy and deal with the experts.</p>
    
  

  <!-- The Team -->
  <div class="w3-row-padding w3-grayscale">
    <div class="w3-half w3-margin-bottom">
      <div class="w3-light-grey">
        <img src="IMG_1345.jpg" alt="Jeff" style="width:100%">
        <div class="w3-container">
          <h3>Jeffrey McGill</h3>
          <p class="w3-opacity">CEO & Founder</p>
          <p>7x AWS Certified with 12 years experience in highly regulated, mission critical, secure environments.</p>
        </div>
      </div>
    </div>
    <div class="w3-half w3-margin-bottom">
      <div class="w3-light-grey">
        <img src="IMG_1335.jpg" alt="Sean" style="width:100%">
        <div class="w3-container">
          <h3>Sean Kidby</h3>
          <p class="w3-opacity">CTO & Founder</p>
          <p>8x AWS Certified and 25 years of experience building technology at some of the world's largest corporations.</p>
        </div>
      </div>
    </div>
    
  </div>
  </div>
  </template>
  
 <script>
export default {
    name: 'Experts'
};
</script> 